module.exports = {
  'align': {
    ''        : require('../assetss/icons/align-left.svg'),
    'center'  : require('../assetss/icons/align-center.svg'),
    'right'   : require('../assetss/icons/align-right.svg'),
    'justify' : require('../assetss/icons/align-justify.svg')
  },
  'background': require('../assetss/icons/background.svg'),
  'blockquote': require('../assetss/icons/blockquote.svg'),
  'bold'      : require('../assetss/icons/bold.svg'),
  'clean'     : require('../assetss/icons/clean.svg'),
  'code'      : require('../assetss/icons/code.svg'),
  'code-block': require('../assetss/icons/code.svg'),
  'color'     : require('../assetss/icons/color.svg'),
  'direction' : {
    ''        : require('../assetss/icons/direction-ltr.svg'),
    'rtl'     : require('../assetss/icons/direction-rtl.svg')
  },
  'float': {
    'center'  : require('../assetss/icons/float-center.svg'),
    'full'    : require('../assetss/icons/float-full.svg'),
    'left'    : require('../assetss/icons/float-left.svg'),
    'right'   : require('../assetss/icons/float-right.svg')
  },
  'formula'   : require('../assetss/icons/formula.svg'),
  'header': {
    '1'       : require('../assetss/icons/header.svg'),
    '2'       : require('../assetss/icons/header-2.svg')
  },
  'italic'    : require('../assetss/icons/italic.svg'),
  'image'     : require('../assetss/icons/image.svg'),
  'indent': {
    '+1'      : require('../assetss/icons/indent.svg'),
    '-1'      : require('../assetss/icons/outdent.svg')
  },
  'link'      : require('../assetss/icons/link.svg'),
  'list': {
    'ordered' : require('../assetss/icons/list-ordered.svg'),
    'bullet'  : require('../assetss/icons/list-bullet.svg'),
    'check'   : require('../assetss/icons/list-check.svg')
  },
  'script': {
    'sub'     : require('../assetss/icons/subscript.svg'),
    'super'   : require('../assetss/icons/superscript.svg'),
  },
  'strike'    : require('../assetss/icons/strike.svg'),
  'underline' : require('../assetss/icons/underline.svg'),
  'video'     : require('../assetss/icons/video.svg')
};



// WEBPACK FOOTER //
// ./ui/icons.js